import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useTranslation, withTranslation } from 'react-i18next';
import { filter } from 'lodash';
import { AlertNotice, ModalInfo, Input } from 'shared/components';
import * as irregularitiesActions from 'features/irregularities/duck';
import * as rostersActions from 'features/rosters/duck';
import * as seatingChartActions from 'features/seating-chart/duck';
import { getNotInRoomEventRegs } from 'features/seating-chart/selectors';
import './SearchExamineeModal.scss';

const searchRegs = (regs, value) =>
  filter(
    regs,
    (reg) =>
      reg.fullName.indexOf(value.toLowerCase()) !== -1 ||
      reg.matchId.indexOf(value.toLowerCase()) !== -1
  );

class SearchExamineeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchExamineeValue: '',
      selectedExaminee: null,
      regs: [],
    };

    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
    this.handleSelectExaminee = this.handleSelectExaminee.bind(this);
    this.handleSelectConfirm = this.handleSelectConfirm.bind(this);
    this.handleSelectCancel = this.handleSelectCancel.bind(this);
  }

  componentDidMount() {
    this.props.actions.getTcEventRegs(this.props.eventId);
  }

  static getDerivedStateFromProps(props, state) {
    const { eventRegs } = props;
    const { searchExamineeValue } = state;

    return {
      ...state,
      regs: searchExamineeValue ? searchRegs(eventRegs, searchExamineeValue) : [],
    };
  }

  onChange(e) {
    const { eventRegs } = this.props;
    const value = e.target.value;
    this.setState({
      searchExamineeValue: value,
      regs: searchRegs(eventRegs, value),
    });
  }

  onClear() {
    this.setState({
      searchExamineeValue: '',
      regs: [],
    });
  }

  handleSelectExaminee(examinee) {
    this.setState({
      selectedExaminee: examinee,
    });
  }

  async handleSelectConfirm() {
    const { actions, roomId, toggleSearchExamineeModal, locationEventId } = this.props;

    const { selectedExaminee } = this.state;

    await actions.assignRegs(locationEventId, {
      roomId: roomId,
      regs: [{ id: selectedExaminee.id }],
    });
    await actions.getStudentsList(roomId);

    this.setState({
      selectedExaminee: null,
    });

    toggleSearchExamineeModal(null, true);
  }

  handleSelectCancel() {
    this.setState({
      selectedExaminee: null,
    });
  }

  render() {
    const { toggleSearchExamineeModal } = this.props;

    const { searchExamineeValue, selectedExaminee, regs } = this.state;

    return (
      <div>
        <ModalInfo
          modalIsOpen
          closeModal={toggleSearchExamineeModal}
          headerTitle="seatingChart.searchExamineeModal.title"
          hideButtons
          className="search-examinee-modal">
          <AlertNotice
            message={`<p>${this.props.t(
              'seatingChart.searchExamineeModal.infoMessage'
            )}</p> <b>${this.props.t('seatingChart.searchExamineeModal.info2Message')}</b>`}
          />

          {selectedExaminee ? (
            <SelectedExaminee
              {...selectedExaminee}
              handleSelectConfirm={this.handleSelectConfirm}
              handleSelectCancel={this.handleSelectCancel}
            />
          ) : (
            <React.Fragment>
              <Input
                label={this.props.t('seatingChart.searchExamineeModal.inputLabel')}
                name="search-examinee-input"
                type="text"
                onChange={this.onChange}
                value={searchExamineeValue}
                infoText={
                  !searchExamineeValue && this.props.t('seatingChart.searchExamineeModal.inputInfo')
                }
                onAddonAction={this.onClear}
                addon={searchExamineeValue && this.props.t('common.labels.clear')}
              />

              <div>
                {regs.map((reg) => (
                  <ExamineeInfo
                    key={`reg-${reg.id}`}
                    reg={reg}
                    handleSelectExaminee={this.handleSelectExaminee}
                  />
                ))}
              </div>
            </React.Fragment>
          )}
        </ModalInfo>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    eventRegs: getNotInRoomEventRegs(state),
    rooms: state.tcEvent.rooms || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...irregularitiesActions,
        ...rostersActions,
        ...seatingChartActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SearchExamineeModal));

SearchExamineeModal.propTypes = {
  t: PropTypes.func.isRequired,
};

SearchExamineeModal.defaultProps = {};

const ExamineeInfo = (props) => {
  const { t } = useTranslation();
  return (
    <div className="examinee-info">
      <div className="name">
        {props.reg.lastName}, {props.reg.firstName}
      </div>
      <div className="match-id">{props.reg.matchId}</div>
      <div className="room">{props.reg.roomName}</div>
      <div className="action">
        <button className="btn" onClick={() => props.handleSelectExaminee(props.reg)}>
          {t('common.labels.add')}
        </button>
      </div>
    </div>
  );
};

const SelectedExaminee = (props) => {
  const { t } = useTranslation();
  return (
    <div className="seelcted-examinee">
      <div>
        <div className="name">
          {props.lastName}, {props.firstName}
        </div>
        <div className="match-id">{props.matchId}</div>
        <div className="room">{props.roomName}</div>
      </div>
      <div className="action">
        <button className="btn btn-small btn-primary" onClick={props.handleSelectConfirm}>
          {t('common.labels.confirm')}
        </button>

        <button className="btn btn-small" onClick={props.handleSelectCancel}>
          {t('common.labels.cancel')}
        </button>
      </div>
    </div>
  );
};
